import React, { useState } from "react";
import { cx } from "utils/join-classnames";
import { Icon, Button } from "ui/components";
import styles from "./SearchField.module.scss";

interface Props {
    theme: "light" | "dark";
    onSubmit(query: string): void;
}

const SearchField: React.FC<Props> = ({ theme, onSubmit }: Props) => {
    const [searchQuery, setSearchQuery] = useState<string>("");

    const handleClear = () => {
        setSearchQuery("");
        onSubmit("");
    };
    const onKeyDown = (e: React.KeyboardEvent) => {
        if (e.key === "Enter") {
            onSubmit(searchQuery);
        }
    };

    return (
        <div className={styles.search}>
            <input
                type="text"
                className={cx(
                    styles.search__field,
                    theme === "dark"
                        ? styles.search__field__dark
                        : styles.search__field__light,
                )}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    setSearchQuery(e.target.value);
                }}
                value={searchQuery}
                placeholder="Search title or tag"
                onKeyDown={onKeyDown}
            />

            {searchQuery.length >= 1 && (
                <div className={styles.search__clear}>
                    <Button
                        type="function"
                        theme="light"
                        icon="close"
                        onClick={handleClear}
                    />
                </div>
            )}
            <div
                className={styles.search__btn}
                onClick={() => onSubmit(searchQuery)}
                role="presentation"
            >
                <Icon name="search" className={styles.search__btn__icon} />
            </div>
        </div>
    );
};

export default React.memo(SearchField);
